// Claim workflow statuses + display helpers
export const CLAIM_STATUSES = [
  "SPK_RECEIVED","WAITING_REGISTRATION","REGISTRATION_COMPLETE","WAITING_PARTS","PARTS_COMPLETE","BOOKING_SERVICE",
  "UNIT_IN","REPAIR_ORDER","READY_TO_DELIVERY","UNIT_OUT","BILLING","INVOICE","RECEIVABLE","PAID","CLOSED",
];

export const PHASE_STATUSES = {
  PRE_ORDER: ["SPK_RECEIVED","WAITING_REGISTRATION","REGISTRATION_COMPLETE","WAITING_PARTS","PARTS_COMPLETE","BOOKING_SERVICE"],
  REPAIR_ORDER: ["UNIT_IN","REPAIR_ORDER","READY_TO_DELIVERY"],
  FINISH_ORDER: ["UNIT_OUT","BILLING","INVOICE","RECEIVABLE","PAID"],
  CLOSED: ["CLOSED"],
};
export function phaseOf(s) { for (const [ph, list] of Object.entries(PHASE_STATUSES)) if (list.includes(s)) return ph; return "PRE_ORDER"; }
export function phaseLabel(ph) { return { PRE_ORDER: "Pre Order", REPAIR_ORDER: "Repair Order", FINISH_ORDER: "Finish Order", CLOSED: "Closed" }[ph] || ph; }
export function phaseClass(ph) { return { PRE_ORDER: "bg-blue-50 text-blue-700 border border-blue-200", REPAIR_ORDER: "bg-amber-50 text-amber-700 border border-amber-200", FINISH_ORDER: "bg-violet-50 text-violet-700 border border-violet-200", CLOSED: "bg-gray-900 text-white border border-gray-900" }[ph] || "bg-gray-100 text-gray-700"; }

export const WORKSHOP_STAGES = [
  "UNIT_IN","DISASSEMBLY","BODY_REPAIR","DEMPUL","PREPARATION","READY_FOR_PAINT",
  "PAINT","ASSEMBLY","POLISH","QC","READY_TO_DELIVERY",
];

export const ORDER_STATUSES = ["NOT_ORDERED","ORDERED","PARTIAL","COMPLETE","NOT_REQUIRED"];
export const RECEIVED_STATUSES = ["NOT_RECEIVED","PARTIAL","RECEIVED","NOT_REQUIRED"];
export const SUPPLY_BY = ["WORKSHOP_SUPPLY","INSURANCE_SUPPLY","NON_SUPPLY","UNKNOWN"];
export const PROCUREMENT_SOURCES = ["INSURANCE_SUPPLY","WORKSHOP_PURCHASE","CUSTOMER_SUPPLY","WAREHOUSE_STOCK","OTHER_MANUAL","UNKNOWN"];
export const PO_STATUSES = ["DRAFT","READY_TO_ORDER","ORDERED","PARTIAL_RECEIVED","COMPLETE"];
export const WORK_TYPES = ["REPAIR","BODY_REPAIR","KETOK","PAINTING","REMOVE_INSTALL","REPLACE_LABOUR","MECHANICAL","ELECTRICAL","GLASS","POLISHING","ALIGNMENT","SUBLET","MATERIAL","OTHER"];

export function label(s) {
  if (!s) return "-";
  return s.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export function procurementStatus(p) {
  const q = Number(p.quantity || 0), rq = Number(p.received_qty || 0);
  if ((p.received_status || "") === "NOT_REQUIRED") return "NOT_REQUIRED";
  if (q > 0 && rq >= q) return "RECEIVED";
  if ((p.procurement_source || "UNKNOWN") === "WORKSHOP_PURCHASE") {
    if (rq > 0) return "PARTIAL_RECEIVED";
    if ((p.order_status || "") === "ORDERED") return "ORDERED";
    return "NOT_ORDERED";
  }
  if (rq > 0) return "PARTIAL_RECEIVED";
  if (p.eta) return "ETA";
  return "WAITING_SUPPLY";
}

export function procurementStatusLabel(s) {
  return s === "ETA" ? "ETA / In Transit" : label(s);
}

export function procurementStatusClass(s) {
  return {
    NOT_ORDERED: "bg-gray-100 text-gray-600",
    WAITING_SUPPLY: "bg-gray-100 text-gray-600",
    ORDERED: "bg-blue-50 text-blue-700",
    ETA: "bg-indigo-50 text-indigo-700",
    PARTIAL_RECEIVED: "bg-amber-50 text-amber-700",
    RECEIVED: "bg-emerald-50 text-emerald-700",
    NOT_REQUIRED: "bg-gray-100 text-gray-500",
  }[s] || "bg-gray-100 text-gray-600";
}

const GROUP = {
  received: "bg-gray-100 text-gray-700 border border-gray-200",
  waiting: "bg-amber-50 text-amber-700 border border-amber-200",
  progress: "bg-blue-50 text-blue-700 border border-blue-200",
  ready: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  billed: "bg-violet-50 text-violet-700 border border-violet-200",
  closed: "bg-gray-900 text-white border border-gray-900",
};

const STATUS_GROUP = {
  SPK_RECEIVED: "received",
  WAITING_REGISTRATION: "waiting", REGISTRATION_COMPLETE: "waiting", WAITING_PARTS: "waiting", BOOKING_SERVICE: "waiting",
  PARTS_COMPLETE: "ready", READY_TO_DELIVERY: "ready",
  UNIT_IN: "progress", REPAIR_ORDER: "progress",
  UNIT_OUT: "billed", BILLING: "billed", INVOICE: "billed", RECEIVABLE: "billed",
  PAID: "closed", CLOSED: "closed",
};

export function statusClass(s) {
  return GROUP[STATUS_GROUP[s] || "received"];
}

export function formatRupiah(v) {
  const n = Math.round(Number(v || 0));
  return "Rp " + n.toLocaleString("id-ID", { maximumFractionDigits: 0 });
}

export function formatRupiahSigned(v) {
  const n = Math.round(Number(v || 0));
  return (n < 0 ? "-Rp " : "Rp ") + Math.abs(n).toLocaleString("id-ID", { maximumFractionDigits: 0 });
}

export function formatDate(iso) {
  if (!iso) return "-";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${dd}/${mm}/${d.getFullYear()}`;
}

export function daysSince(iso) {
  if (!iso) return 0;
  const d = new Date(iso);
  if (isNaN(d)) return 0;
  return Math.floor((Date.now() - d.getTime()) / 86400000);
}

// Recompute an item's approved total = approved_unit_price * qty; discount_amount = gross - total
export function recalcItem(it) {
  const qty = Number(it.qty ?? it.quantity ?? 1) || 0;
  const priceList = Number(it.price_list || 0);
  const approvedUnit = Number(it.approved_unit_price || 0);
  const total = approvedUnit ? approvedUnit * qty : Number(it.total_approved || 0);
  const gross = priceList ? priceList * qty : total;
  return { ...it, total_approved: Math.round(total), discount_amount: Math.max(0, Math.round(gross - total)) };
}
